(() => {
  class AdminConfigController {
    constructor($scope, $log, Business, ngDialog, toastr, Utils) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $log,
        ngDialog,
        Utils,
        toastr,
        Business,
        configurations: {}
      }); // Data is being manipulated in the business service before reaching here

      Business.getPlatformStatus().then(data => {
        $log.log('Platform Statuses: ', data);
        this.statuses = Utils.sortObjectByKeys(data);
        this.statusesMaster = angular.copy(this.statuses);
      });
      ['ios', 'android'].forEach(device => {
        Business.getPlatformConfig(device).then(({
          data
        }) => {
          this.config(device, data);
        });
      });
    }

    config(device, config) {
      // Pluck out global configurations if we don't have them set yet
      if (!this.configurations.all) {
        this.configurations.all = _.filter(config, opt => opt.type === 'all');
      }

      config = _.reject(config, opt => opt.type === 'all');
      this.configurations[device] = config;
      this.configurations = this.Utils.sortObjectByKeys(this.configurations);
    }

    hasStatusesChanged() {
      return !angular.equals(this.statusesMaster, this.statuses);
    }

    cancelStatusUpdate() {
      this.statuses = angular.copy(this.statusesMaster);
    }

    updateApi() {
      _.each(this.Utils.findDifference(this.statusesMaster, this.statuses), (status, platform) => {
        this.Business.updatePlatformStatus(platform, status, this.reason).then(() => {
          this.statusesMaster = angular.copy(this.statuses);
        }).catch(err => {
          this.statuses[platform] = !status;

          if (err.status === 403) {
            this.toastr.error('Only administrators may perform this action.');
          }
        });
      });
    }

    updateConfig(opt) {
      this.Business.updateConfig(opt.id, opt.value).then(() => {
        this.toastr.success('Configuration saved.');
      }).catch(err => {
        if (err.status === 403) {
          this.toastr.error('Only administrators may perform this action.');
        } else {
          this.toastr.error('Something went wrong, please try again.');
        }
      });
    }

  }

  AdminConfigController.$inject = ["$scope", "$log", "Business", "ngDialog", "toastr", "Utils"];
  angular.module('pims').controller('AdminConfigController', AdminConfigController);
})();